/* Apollo shared + phone fixes - 2026-11-02. Runs on every screen size; the phone-only part checks PHONE. */
(function(){
  'use strict';
  var D = document, CDNF = 'https://cdn.shopify.com/s/files/1/0887/0277/9709/files/', PHONE = !window.matchMedia('(min-width: 900px)').matches;

  /* 0. wholesale mix (all pages): the add-on deal (a Shopify buy-X-get-Y discount) keeps one unit out of the 4+ wholesale
     tier, so a cart with 4+ of either product came out above the price list (each product at its pack price, $10 off once
     for having both, no $10 when both are 4+). Gap: both 4+ -> $4 (4 shilajit) / $5 (5+); 1-3 shilajit + 4+ beetroot or
     4 shilajit + 1-3 beetroot -> $7; 5+ shilajit + 1-3 beetroot -> $8. Apply the matching correction code, and take it
     off when the cart stops qualifying. Codes the customer typed are kept. The codes need 5-9 items, so alone they are worth little. */
  var SH_PID = 9587266683197, BT_PID = 10286493139261, BU_PID = 10310411845949, MIX = ['WHOLESALE-MIX-4', 'WHOLESALE-MIX-5', 'WHOLESALE-MIX-7', 'WHOLESALE-MIX-8'], mixBusy = false, mixAgain = false;
  /* bundles don't change the code: the bundle tier discounts combine with order codes (since Nov 3) */
  function mixCode(s, b){
    if (!s || !b) return '';
    if (s >= 4 && b >= 4) return MIX[s === 4 ? 0 : 1];
    if (b >= 4 || s === 4) return MIX[2];
    if (s >= 5) return MIX[3];
    return '';
  }
  var mixAt = 0;
  function mixCheck(){
    /* a request that never answered must not switch this off for good */
    if (mixBusy && Date.now() - mixAt < 12000){ mixAgain = true; return; }
    mixBusy = true; mixAt = Date.now();
    /* read the cart with XHR: vg-cart's fetch wrapper can answer /cart.js from an 8-second cache */
    new Promise(function(ok, no){
      var x = new XMLHttpRequest(); x.open('GET', '/cart.js'); x.setRequestHeader('Cache-Control', 'no-cache');
      x.onload = function(){ try { ok(JSON.parse(x.responseText)); } catch (er){ no(er); } }; x.onerror = no; x.send();
    }).then(function(c){
      var s = 0, b = 0, u = 0;
      (c.items || []).forEach(function(i){ if (i.product_id === SH_PID) s += i.quantity; if (i.product_id === BT_PID) b += i.quantity; if (i.product_id === BU_PID) u += i.quantity; });
      var want = mixCode(s, b);
      var codes = (c.discount_codes || []).map(function(d){ return d.code; });
      var ours = codes.filter(function(k){ return MIX.indexOf(k.toUpperCase()) > -1; });
      if (want ? (ours.length === 1 && ours[0].toUpperCase() === want) : !ours.length) return;
      var keep = codes.filter(function(k){ return MIX.indexOf(k.toUpperCase()) < 0; });
      /* Shopify re-splits the lines under new keys when the code changes: vg-cart holds +/- taps until this is back,
         then the drawer is redrawn from the new cart (a + tapped mid-swap used to land on a stale line) */
      window.__vgMixBusy = true;
      return window.fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({discount: keep.concat(want ? [want] : []).join(',')})})
        .then(function(r){ return r.json(); }).then(function(nc){
          window.__vgMixBusy = false;
          if (!nc || !nc.items) return;
          window.__vgLastCart = nc;
          if (window.vgCart && window.vgCart.redraw) return window.vgCart.redraw(false);
          var t = '$' + (nc.total_price / 100).toFixed(2).replace(/\.00$/, '') + ' USD';
          [].forEach.call(D.querySelectorAll('.wt-cart__subtotal__value'), function(el){ if (el.textContent.trim() !== t) el.textContent = t; });
        });
    }).catch(function(){}).then(function(){
      window.__vgMixBusy = false;
      mixBusy = false;
      if (mixAgain){ mixAgain = false; setTimeout(mixCheck, 300); }
    });
  }
  /* the correction code showed as "WHOLESALE-MIX-8 (-$8)" in the cart and drawer: say what it is */
  function mixLabel(){
    [].forEach.call(D.querySelectorAll('.discounts__discount, .wt-cart__discount, [class*="discount"] li'), function(el){
      var w = D.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) if (/WHOLESALE-MIX-\d+/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/WHOLESALE-MIX-\d+/ig, 'Wholesale price');
    });
  }
  var mixLT = 0;
  new MutationObserver(function(){ if (!mixLT) mixLT = requestAnimationFrame(function(){ mixLT = 0; mixLabel(); }); }).observe(D.documentElement, {childList: true, subtree: true});
  mixLabel();
  var mixT = 0;
  function mixSoon(ms){ clearTimeout(mixT); mixT = setTimeout(mixCheck, ms || 700); }
  D.addEventListener('cart:updated', function(){ mixSoon(300); });
  /* quantity steppers, trash buttons and add buttons that update the cart without the event */
  D.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('cart-drawer, cart-items, .cart-page, form[action*="/cart"], .vg-sticky, .apx-qty, .apxp, .vgu-card')) mixSoon(1600);
  }, true);
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function(){ mixSoon(400); }); else mixSoon(400);

  /* 0b. cart page: the store's money format has no decimals, so the server printed the $49.99 bundle as $50 and a
     $129.99 cart as $130 while checkout charges the cents. Rewrite the rounded line totals and the subtotal from
     /cart.js. Rows are #CartDrawer-Item-N in cart order; only amounts that really have cents are touched. */
  if (/^\/cart\/?$/.test(location.pathname)){
    var exactT = 0;
    var exactMoney = function(){
      var x = new XMLHttpRequest(); x.open('GET', '/cart.js'); x.setRequestHeader('Cache-Control', 'no-cache');
      x.onload = function(){
        var c; try { c = JSON.parse(x.responseText); } catch (er){ return; }
        var main = D.querySelector('main'); if (!main || !c.items) return;
        var fm = function(v){ return '$' + (v / 100).toFixed(2).replace(/\.00$/, ''); };
        var fix = function(root, v){
          if (!root || v % 100 === 0) return;
          var round = '$' + Math.round(v / 100), tw = D.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
          while ((n = tw.nextNode())) if (n.nodeValue.trim() === round) n.nodeValue = n.nodeValue.replace(round, fm(v));
        };
        c.items.forEach(function(it, i){
          var row = main.querySelector('#CartDrawer-Item-' + (i + 1));
          fix(row, it.final_line_price); fix(row, it.original_line_price); fix(row, it.original_price);
        });
        if (c.total_price % 100){
          var t = fm(c.total_price) + ' USD';
          [].forEach.call(main.querySelectorAll('.wt-cart__subtotal__value'), function(el){ if (el.textContent.trim() !== t) el.textContent = t; });
        }
      };
      x.send();
    };
    var exactSoon = function(){ clearTimeout(exactT); exactT = setTimeout(exactMoney, 150); };
    D.addEventListener('cart:updated', exactSoon);
    var exactStart = function(){
      exactMoney();
      /* the theme swaps the rows in after every quantity change (childList); the text edits above do not retrigger */
      var m = D.querySelector('main'); if (m) new MutationObserver(exactSoon).observe(m, {childList: true, subtree: true});
    };
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', exactStart); else exactStart();
  }

  /* 0c. how-to guide: a tab scrolls smoothly to its part, and on the way the scroll-spy lit the tabs it passed
     (tap "Both" and "Beetroot" flashed on). Keep the tapped tab lit until the scroll has settled. */
  D.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.gd-tabs button'); if (!b) return;
    var row = b.parentNode, bs = row.querySelectorAll('button'), until = Date.now() + 1200;
    var mo = new MutationObserver(function(){
      if (Date.now() > until) { mo.disconnect(); return; }
      for (var i = 0; i < bs.length; i++) { var on = bs[i] === b; if (bs[i].classList.contains('is-on') !== on) bs[i].classList.toggle('is-on', on); }
    });
    mo.observe(row, {subtree: true, attributes: true, attributeFilter: ['class']});
    setTimeout(function(){ mo.disconnect(); }, 1300);
  });

  /* 0d. menu, for keyboard and screen-reader users: the burger had no name, and the closed menu's ten links stayed in
     the Tab order, so keyboard users tabbed through links they could not see. Name the button, keep it in step with
     the drawer, and make the closed drawer inert. */
  (function(){
    var btn = D.querySelector('.custom-header__menu'), dr = D.querySelector('.custom-menu-drawer'); if (!btn || !dr) return;
    btn.setAttribute('aria-controls', dr.id);
    var sync = function(){
      var open = dr.classList.contains('is-open');
      dr.inert = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    };
    sync();
    new MutationObserver(sync).observe(dr, {attributes: true, attributeFilter: ['class']});
  })();

  /* 1. phone, product pages: the closed story player (opacity 0) held all six full story videos with preload=auto
     and played one in the background, so they fought the page photos for the connection as it opened. Unload them
     while the player is closed; a tap on a story puts them back before the theme opens it. */
  if (PHONE && /\/products\//.test(location.pathname)) {
    var wake = 0;
    var hold = function(){
      if (Date.now() < wake) return;
      [].forEach.call(D.querySelectorAll('[class*="video-modal-template--"]'), function(m){
        if (getComputedStyle(m).opacity !== '0') return;
        [].forEach.call(m.querySelectorAll('video'), function(v){
          if (v.dataset.vgHeld) { if (!v.paused) v.pause(); return; }
          var s = v.getAttribute('src'); if (!s) return;
          v.dataset.vgHeld = s; v.pause(); v.removeAttribute('src'); v.preload = 'none'; v.load();
        });
      });
    };
    D.addEventListener('click', function(e){
      if (!e.target.closest || !e.target.closest('.vg-stories, [class*="video-slide-template--"]')) return;
      wake = Date.now() + 2500;
      [].forEach.call(D.querySelectorAll('video[data-vg-held]'), function(v){ v.setAttribute('src', v.dataset.vgHeld); delete v.dataset.vgHeld; v.preload = 'auto'; });
    }, true);
    hold(); setInterval(hold, 500);
    /* "Real People, Real Results": fetch the cover pictures once the page has loaded, so they are sharp on arrival */
    window.addEventListener('load', function(){ setTimeout(function(){
      [].forEach.call(D.querySelectorAll('.vgr video[poster]'), function(v){ (new Image()).src = v.poster; });
    }, 800); });
  }

  /* 1b. bundle price on product cards (search results, predictive search, recommendations): the store money format has no
     decimals, so Liquid prints the bundle's $49.99 as $50. Fix the text wherever a card links to the bundle. */
  var b50 = function(){
    [].forEach.call(D.querySelectorAll('a[href*="/products/the-ultimate-bundle"]'), function(a){
      var c = a; for (var i = 0; i < 6 && c && !c.querySelector('[class*=price]'); i++) c = c.parentElement;
      if (!c) return;
      [].forEach.call(c.querySelectorAll('[class*=price] *, [class*=price]'), function(e){
        if (e.children.length === 0 && e.textContent.trim() === '$50') e.textContent = '$49.99';
      });
    });
  }, b50t;
  b50();
  new MutationObserver(function(){ clearTimeout(b50t); b50t = setTimeout(b50, 250); }).observe(D.body, {childList: true, subtree: true});

  if (!/\/products\/the-ultimate-bundle/.test(location.pathname)) return;
  D.documentElement.classList.add('vgb-page');

  /* 2. bundle page sticky bar: the picture follows the chosen pack (1, 2 or 3 of each) like the shilajit and beetroot
     bars, and the price updates on the tap instead of on the next timer tick. Same text format as vg-chrome's buSticky. */
  [1, 2, 3].forEach(function(q){ (new Image()).src = CDNF + 'vg-qbu-' + q + 'd.png?width=200'; });
  function pack(){
    var bar = D.querySelector('.vg-sticky'); if (!bar) return;
    var on = D.querySelector('.apx-tier.is-on[data-q]') || D.querySelector('.apx-tier[data-q="1"]'), q = on ? on.getAttribute('data-q') : '1';
    var im = bar.querySelector('.vgb-img');
    if (!im) { im = D.createElement('img'); im.className = 'vgb-img'; im.alt = ''; im.width = 46; im.height = 46; bar.insertBefore(im, bar.firstChild); bar.classList.add('vgb-sticky'); }
    var want = CDNF + 'vg-qbu-' + q + 'd.png?width=200'; if (im.getAttribute('src') !== want) im.src = want;
    /* two older timers share .vg-sticky__p (one fills it, one blanks it for lack of shilajit-style rows), so the
       price flickered or vanished; the bar gets its own line and .vg-sticky__p is hidden in custom.css */
    var p = bar.querySelector('.vgb-p'), old = bar.querySelector('.vg-sticky__p');
    if (!p && old) { p = D.createElement('span'); p.className = 'vgb-p'; old.parentNode.insertBefore(p, old.nextSibling); }
    var tot = on && on.getAttribute('data-total'),
        txt = tot ? '$' + (+tot % 1 ? (+tot).toFixed(2) : +tot) + ' · ' + q + (q === '1' ? ' bundle' : ' bundles') : '';
    if (p && txt && p.textContent !== txt) p.textContent = txt;
  }
  D.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('.apx-tier')) setTimeout(pack, 0); }, true);
  setInterval(pack, 600);

  /* 3. bundle page, below "A licensed, registered British company": how both fit into a normal week (styles in
     custom.css .apx-wk). Waits for "From the mountain and the soil" (.vg-sf) so vg-chrome has built its own sections first. */
  var tries = 0, week = setInterval(function(){
    var proof = D.querySelector('.apx-proofsec');
    if ((!proof || !D.querySelector('.vg-sf')) && ++tries < 40) return;
    clearInterval(week);
    if (!proof || D.querySelector('.apx-wk')) return;
    var IMG = function(f){ return CDNF + f + '?width=720'; }, s = D.createElement('section');
    var card = function(cls, img, alt, tag, h, p, st){ return '<article class="apx-wk__c ' + cls + '"><img loading="lazy" width="720" height="540" src="' + IMG(img) + '" alt="' + alt + '"><div class="apx-wk__t"><span class="apx-wk__tag">' + tag + '</span><h3>' + h + '</h3><p>' + p + '</p><small>' + st + '</small></div></article>'; };
    s.className = 'apx-wk';
    s.innerHTML = '<div class="apx-wk__in"><span class="apx-wk__k">Your week with Apollo</span><h2 class="apx-wk__h">One routine, <em>every</em> kind of day.</h2>'
      + '<p class="apx-wk__lead">Work day, training day or rest day, it takes about two minutes.</p><div class="apx-wk__row">'
      + card('is-sh', 'apx-wk-morning.jpg', 'Apollo shilajit stirred into a glass mug of warm water', 'Work day · Morning', 'Start with the resin', 'A pea-sized amount of shilajit (about half a gram) in warm water, tea or coffee.', 'Shilajit · Steady energy · Focus')
      + card('is-bt', 'apx-wk-training.jpg', 'Shilajit and a beetroot scoop going into a shaker at the gym', 'Training day · Pre-workout', 'Add the scoop', 'Morning shilajit as usual, then one 5 g scoop of beetroot in water or juice before you train.', 'Both · Blood flow · Stamina')
      + card('is-sh', 'apx-wk-rest.jpg', 'Apollo shilajit and beetroot on a café table', 'Rest day · With breakfast', 'Keep it going', 'Shilajit as usual and the beetroot scoop with breakfast. Rest days count too.', 'Both · Recovery · Consistency')
      + '</div><div class="apx-wk__day"><div><em>Day 1</em><b>Habit</b>Same time, every day</div><div><em>Day 14</em><b>Notice</b>Most people start to feel it</div><div><em>Day 30</em><b>Judge</b>Give it a full month</div></div>'
      + '<div class="apx-wk__cta"><div class="apx-wk__price"><b>$49.99</b><s>$60</s><em>You save $10</em></div><span class="apx-wk__note">Free delivery across Lebanon · cash on delivery</span><button type="button" class="apx-wk__btn">Choose 1, 2 or 3 bundles</button></div></div>';
    proof.parentNode.insertBefore(s, proof.nextSibling);
    s.querySelector('.apx-wk__btn').addEventListener('click', function(){
      var q = D.querySelector('.apx-qty'); if (q) window.scrollTo({top: q.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth'});
    });
  }, 250);

})();

/* Apollo desktop fixes - 2026-11-02. Desktop only: phones return on the first line, so mobile is unchanged. */
(function(){
  'use strict';
  if (!window.matchMedia('(min-width: 900px)').matches) return;
  var D = document, CDNF = 'https://cdn.shopify.com/s/files/1/0887/0277/9709/files/';

  /* 0. product pages: show the buy column (hidden by custom.css) once its blocks stop moving - the UK card and terms
     line are in and nothing has moved for 400 ms - or after 2.6 s at the latest */
  (function(){
    var root = D.documentElement, t0 = Date.now(), sig = '', calm = 0;
    function show(){ root.classList.add('vgd-col-ok'); }
    if (!/\/products\//.test(location.pathname)) return show();
    (function look(){
      var col = D.querySelector('.wt-product__info.product__info-container');
      if (!col) { if (D.readyState !== 'loading') return show(); return setTimeout(look, 100); }
      var now = [].map.call(col.children, function(k){ return (k.className + '').slice(0, 14) + ':' + k.offsetTop + ':' + k.offsetHeight; }).join('|');
      if (now === sig) calm += 100; else { calm = 0; sig = now; }
      if ((calm >= 400 && D.querySelector('.apx-uk') && D.querySelector('.apx-terms')) || Date.now() - t0 > 2600) return show();
      setTimeout(look, 100);
    })();
  })();

  /* 1. header: the main links next to the menu button */
  var left = D.querySelector('.custom-header__left');
  if (left && !left.querySelector('.vgd-nav')) {
    var nav = D.createElement('nav'); nav.className = 'vgd-nav'; nav.setAttribute('aria-label', 'Main');
    [['Shilajit', '/products/shilajit-resin'], ['Beetroot', '/products/beetroot-performance-formula'], ['The Bundle', '/products/the-ultimate-bundle'], ['Lab tested', '/pages/lab-tested']].forEach(function(l){
      var a = D.createElement('a'); a.href = l[1]; a.textContent = l[0]; if (location.pathname === l[1]) a.className = 'is-on'; nav.appendChild(a);
    });
    left.appendChild(nav);
  }

  /* 2. bundle page: the pack pictures are above the fold - load them now, not last */
  [].forEach.call(D.querySelectorAll('img.vg-tier-img[loading="lazy"]'), function(i){ i.loading = 'eager'; i.fetchPriority = 'high'; });

  /* 3. sharp photos: the sections ask Shopify for phone-sized files (?width=500/600/1100). On a desktop - and a
     retina one at that - those get stretched and look soft. Ask for the size each photo is really drawn at. */
  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  function want(im){
    var r = im.getBoundingClientRect(); if (r.width < 120) return 0;
    var w = r.width;
    if (getComputedStyle(im).objectFit === 'cover' && im.naturalWidth && im.naturalHeight) w = Math.max(r.width, r.height * im.naturalWidth / im.naturalHeight);
    return Math.min(2400, Math.ceil(w * DPR / 100) * 100);
  }
  function sharpen(){
    [].forEach.call(D.querySelectorAll('#root img[src*="/files/"], #root img[src*="/cdn/shop/"]'), function(im){
      var src = im.getAttribute('src'), m = /[?&]width=(\d+)/.exec(src); if (!m) return;
      var need = want(im); if (!need || need <= +m[1]) return;
      var set = im.getAttribute('srcset'); if (set) { var best = 0; set.replace(/(\d+)w/g, function(_, n){ best = Math.max(best, +n); }); if (best >= need) return; }
      im.removeAttribute('srcset'); im.removeAttribute('sizes');
      im.setAttribute('src', src.replace(/([?&]width=)\d+/, '$1' + need));
    });
  }
  if (D.readyState === 'complete') sharpen(); else window.addEventListener('load', sharpen);
  var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(sharpen, 300); });

  /* 4. homepage badge strip: the run was built for a phone, so on a wide screen its end slid into view and left
     an empty band on the right. Repeat the badges until the run is over twice the screen; an even number of sets
     keeps the -50% loop seamless, and the duration grows with it so the speed stays the same. */
  var run = D.querySelector('.ah-badges__run');
  if (run && !run.dataset.vgLoop && run.children.length % 2 === 0) {
    run.dataset.vgLoop = '1';
    var set = [].slice.call(run.children, 0, run.children.length / 2), setW = run.scrollWidth / 2, copies = 2;
    if (setW > 0) {
      while (copies * setW < 2 * Math.max(window.screen.width, window.innerWidth) + setW) copies += 2;
      for (var c = 2; c < copies; c++) set.forEach(function(n){ var k = n.cloneNode(true); k.setAttribute('aria-hidden', 'true'); run.appendChild(k); });
      run.style.animationDuration = (7 * copies) + 's';
    }
  }

  /* 5. "Better Together" banner: a short list of what is in the box, using the claims already on the site */
  var bunD = D.querySelector('.ah-bun__d');
  if (bunD && !D.querySelector('.ah-bun__list')) {
    var ul = D.createElement('ul'); ul.className = 'ah-bun__list';
    [['Shilajit resin, 30g', 'pure Himalayan, about 60 daily servings'], ['Beetroot powder, 200g', '40 scoops, mixes into any drink'], ['Lab tested', 'every batch, ISO/IEC 17025 certified lab'], ['UK registered', 'registered & licensed in the United Kingdom']].forEach(function(x){
      var li = D.createElement('li'), b = D.createElement('b'); b.textContent = x[0];
      li.appendChild(b); li.appendChild(D.createTextNode(' · ' + x[1])); ul.appendChild(li);
    });
    bunD.parentNode.insertBefore(ul, bunD.nextSibling);
  }

  /* 6. beetroot page, "Real People, Real Results": one more customer video. vg-chrome.js builds the row after load
     and opens videos from its own list, so this card gets its own player (same .vgx markup) instead of data-i. */
  if (/\/products\/beetroot/.test(location.pathname)) {
    var VID = '2016266627854b0782a4d700e336c718', VSRC = 'https://cdn.shopify.com/videos/c/vp/' + VID + '/' + VID + '.SD-480p-0.9Mbps-81815046.mp4',
        VPOST = CDNF + 'preview_images/' + VID + '.thumbnail.0000000000.jpg?width=420', tries = 0;
    var addVid = setInterval(function(){
      var last = D.querySelector('.vgr .vgr__row > .vgr__c:last-of-type');
      if (!last && ++tries < 40) return;
      clearInterval(addVid);
      if (!last || D.querySelector('.vgd-extra')) return;
      var card = last.cloneNode(true), v = card.querySelector('video');
      card.classList.add('vgd-extra'); card.removeAttribute('data-i');
      if (v) { v.removeAttribute('data-src'); v.poster = VPOST; v.muted = true; v.autoplay = true; v.preload = 'metadata'; v.src = VSRC; }
      card.addEventListener('click', function(e){
        e.stopPropagation();
        var m = D.createElement('div'); m.className = 'vgx'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
        m.innerHTML = '<div class="vgx__box"><video playsinline controls autoplay preload="auto"></video><button type="button" class="vgx__x" aria-label="Close video">&times;</button></div>';
        var mv = m.querySelector('video'); mv.src = VSRC; mv.poster = VPOST;
        m.addEventListener('click', function(ev){ if (ev.target === m || ev.target.closest('.vgx__x')) m.remove(); });
        D.body.appendChild(m);
      });
      last.parentNode.appendChild(card);
    }, 250);
  }

  /* 7. cart page: the same clean pack pictures the drawer uses, and a readable upsell picture.
     Only image src is touched (an attribute), so the childList observer below never re-triggers itself. */
  if (!/^\/cart\/?$/.test(location.pathname)) return;
  function cut(handle, q){
    if (/shilajit-resin/.test(handle)) return q >= 3 ? 'vg-qbj-3b.png' : q === 2 ? 'vg-qbj-2.png' : 'vg-qbj-1.png';
    if (/beetroot/.test(handle)) return q >= 3 ? 'vg-qbb-3g.png' : q === 2 ? 'vg-qbb-2g.png' : 'vg-qbb-1g.png';
    if (/ultimate-bundle/.test(handle)) return 'vg-bundle-cut.png';
    return null;
  }
  function setSrc(im, f){
    if (!im || !f) return; var u = CDNF + f + '?width=240';
    if (im.getAttribute('src') === u) return;
    im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.setAttribute('src', u);
  }
  function fix(){
    [].forEach.call(D.querySelectorAll('#main-cart-items .cart-item'), function(r){
      var a = r.querySelector('a[href*="/products/"]'), qi = r.querySelector('input[name="updates[]"]');
      setSrc(r.querySelector('.wt-cart__item__thumb img'), cut(a ? a.getAttribute('href') : '', parseInt(r.dataset.vgQty || (qi && qi.value), 10) || 1));
    });
    var card = D.querySelector('#main-cart-footer .apxb__card');
    if (card) setSrc(card.querySelector('.apxb__img'), /beetroot/i.test(card.textContent) ? cut('beetroot', 1) : /shilajit/i.test(card.textContent) ? cut('shilajit-resin', 1) : null);
  }
  var queued = false;
  function later(){ if (queued) return; queued = true; requestAnimationFrame(function(){ queued = false; fix(); }); }
  fix();
  ['main-cart-items', 'main-cart-footer'].forEach(function(id){ var el = D.getElementById(id); if (el) new MutationObserver(later).observe(el, {childList: true, subtree: true}); });
})();
